import Modal from '@mui/material/Modal';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import ActionButton from '@source/components/ActionButton';
import * as S from './styles';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
};

const modalStyle = {
  display: 'grid',
  placeItems: 'center',
  height: '100vh',
  width: '100vw'
};

const DownloadModal: React.FC<Props> = ({
  isOpen,
  closeModal
}): JSX.Element => {
  return (
    <Modal open={isOpen} onClose={closeModal} sx={modalStyle}>
      <S.Box>
        <S.Text>
          Para fazer o download desse conteúdo, preencha algumas informações
        </S.Text>

        <S.Divider />

        {/* <FormControl variant="standard"> */}
        <OutlinedInput
          id="input-with-icon-adornment"
          placeholder="Digite seu nome"
          sx={{ borderRadius: '1.2rem' }}
          startAdornment={
            <InputAdornment position="start">
              <PersonOutlineIcon />
            </InputAdornment>
          }
        />

        <OutlinedInput
          id="input-with-icon-adornment"
          placeholder="Digite seu e-mail"
          sx={{ borderRadius: '1.2rem', margin: '2.4rem 0' }}
          startAdornment={
            <InputAdornment position="start">
              <MailOutlineIcon />
            </InputAdornment>
          }
        />
        {/* </FormControl> */}

        <ActionButton label="Fazer download" labelcolor="blue" />
      </S.Box>
    </Modal>
  );
};

export default DownloadModal;
